import { Component } from '@angular/core';
import { BaseComponent } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { combineLatest, Subscription } from 'rxjs';

import { IKrankheitenResponse, KrankheitenQueryFilterConfig } from 'fa-kt.types';
import { KrankheitenService } from '.';

@Component({
  selector: 'fa-kt-krankheiten-filter',
  template: `<pbc-filter [config]="KrankheitenFilterConfig" [filter]="krankheiten.filter$ | async" (filterChange)="krankheiten.filter$.next($event)"></pbc-filter>`,
})
export class KrankheitenFilterComponent extends BaseComponent {
  readonly subscriptions: Subscription[] = [];

  public KrankheitenFilterConfig: IFilterConfig<IKrankheitenResponse>;

  constructor(public krankheiten: KrankheitenService) {
    super();
    this.KrankheitenFilterConfig = KrankheitenQueryFilterConfig.map((filter) => ({ ...filter, title: get(this.sitemap, filter.title, filter.title) as string }));
  }

  override ngOnInit() {
    super.ngOnInit();
    this.subscriptions.push(
      combineLatest([this.krankheiten.shapes$, this.meta.users$]).subscribe(([shapes, users]) => {
        if (!shapes) return;
        this.shape('krankheit.mitarbeiter', users);
      }),
    );
  }

  override ngOnDestroy() {
    super.ngOnInit();
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.KrankheitenFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.KrankheitenFilterConfig[index].selections = shapes;
  }
}
